import React from "react";

// Lib
import { Helmet } from "react-helmet";

interface IHelmetCeo {
	data?: { [index: string]: string }[],
}

export const HelmetCeo: React.FC<IHelmetCeo> = ({ data = [] }) => {
	if(!data?.length) return null;

	return (
		<Helmet>
			{data?.length ?
				data.map((item: { [index: string]: string } ) => <meta key={item.name} name={item.name} content={item.content} />)
				: null}
		</Helmet>
	);
};

export default HelmetCeo;
